/* eslint-disable react/no-array-index-key */
import { Box, Button, Checkbox, Icon, IconButton, Input, Tooltip } from '@bitrise/bitkit';
import { Controller, UseFieldArrayReturn, useFormContext, useFieldArray } from 'react-hook-form';
import FormBlock from '../FormBlock/FormBlock';
import { BuildConfigurationType } from '../types';
import { BuildEnvironment } from '../../../../../models/TriggerParams';

export interface CustomVarsProps {
  isLastItem?: boolean;
}

interface InputGroupProps {
  index: number;
  remove: UseFieldArrayReturn<BuildConfigurationType>['remove'];
}

const InputGroup = (props: InputGroupProps) => {
  const { remove, index } = props;
  const { control } = useFormContext<BuildConfigurationType>();

  return (
    <div>
      <Box display="flex" marginBlockEnd="12" gap="16">
        <Controller
          render={({ field: { ref, ...fieldProps } }) => (
            <Input inputRef={ref} leftIconName="Dollars" flex={1} placeholder="KEY" {...fieldProps} />
          )}
          name={`${'environments'}.${index}.mappedTo`}
          control={control}
        />
        <Controller
          render={({ field: { ref, ...fieldProps } }) => (
            <Input inputRef={ref} flex={1} placeholder="VALUE" {...fieldProps} />
          )}
          name={`${'environments'}.${index}.value`}
          control={control}
        />
        <IconButton iconName="Trash" aria-label="Remove" variant="secondary" onClick={() => remove(index)} />
      </Box>
      <Controller
        render={({ field: { ref, value, onChange } }) => (
          <Checkbox onChange={onChange} ref={ref} isChecked={value}>
            Replace variables in input{' '}
            <Tooltip label="Enable this if you want to replace Environment Variables in your input with the variable's assigned value.">
              <Icon name="Info" size="16" tabIndex={0} />
            </Tooltip>
          </Checkbox>
        )}
        name={`environments.${index}.isExpand`}
        control={control}
      />
    </div>
  );
};

const CustomVars = (props: CustomVarsProps) => {
  const { isLastItem } = props;
  const { control } = useFormContext<BuildConfigurationType>();

  const { append, fields, remove } = useFieldArray({
    control,
    name: 'environments',
  });

  return (
    <FormBlock isLastItem={isLastItem} title="Custom Environment Variables">
      {fields.map((item, index) => {
        return <InputGroup index={index} key={item.mappedTo + index} remove={remove} />;
      })}
      <Button
        leftIconName="PlusCircle"
        variant="secondary"
        width="100%"
        onClick={() => {
          const appendObject: BuildEnvironment = { isExpand: true, mappedTo: '', value: '' };
          append(appendObject);
        }}
      >
        Add a custom Env Var
      </Button>
    </FormBlock>
  );
};

export default CustomVars;
